import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatMenuModule } from '@angular/material/menu'
import { TranslateModule } from '@ngx-translate/core'

import { TemplateMessageComponent } from './template-message.component'

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatMenuModule,
    TranslateModule,
  ],
  declarations: [TemplateMessageComponent],
  exports: [TemplateMessageComponent],
})
export class TemplateMessageModule {}
